<template>
  <q-dialog
    v-model="shown"
    :maximized="$q.screen.lt.sm"
  >
    <q-card
      :style="$q.screen.lt.sm ? '' : 'width: 700px; max-width: 1000px'"
    >
      <q-card-section class="row items-center q-mx-xs">
        <div
          class="text-h6 text-center"
        >
          Managing {{ currentRegisterClient.registerStation.name }}
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <div>
          <q-markup-table
            flat
            bordered
            class="status-table"
          >
            <tbody>
              <tr>
                <td
                  colspan="2"
                  class="status-label"
                  style="font-size: 18px;"
                >
                  {{ registerStation ? registerStation.name : 'No Register Station' }}
                </td>
              </tr>
              <tr>
                <td class="status-label">
                  Network Connection
                </td>
                <td class="text-center">
                  <q-icon
                    :name="onLine ? 'wifi' : 'wifi_off'"
                    size="md"
                    :color="onLine ? 'green' : 'red'"
                  />
                </td>
              </tr>
              <tr>
                <td class="status-label">
                  Server Connection
                </td>
                <td class="text-center">
                  <q-icon
                    :name="!cableDisconnected ? 'cloud_done' : 'cloud_off'"
                    size="md"
                    :color="(!onLine && 'grey') || (!cableDisconnected ? 'green' : 'red')"
                  />
                </td>
              </tr>
              <tr v-if="hardware && !electronMode">
                <td class="status-label">
                  <div>
                    Hardware Online
                  </div>
                  <div
                    v-if="hardware.lastSeenAt"
                    class="text-overline"
                    style="line-height: 18px"
                  >
                    {{ hardware.lastSeenAt.relativeTime() }}
                  </div>
                  <div
                    v-if="hardware.status.ipAddress"
                    class="text-overline"
                    style="line-height: 18px"
                  >
                    {{ hardware.status.ipAddress }}
                  </div>
                  <div
                    v-if="hardware.status.softwareVersion"
                    class="text-overline"
                    style="line-height: 18px; height: 5px;"
                  >
                    v{{ hardware.status.softwareVersion }}
                  </div>
                </td>
                <td
                  class="text-center q-pt-md"
                  style="vertical-align: top;"
                >
                  <div>
                    <q-icon
                      :name="hardware.status.connected ? 'cloud_done' : 'cloud_off'"
                      size="md"
                      :color="((!onLine || cableDisconnected) && 'grey') || (hardware.status.connected ? 'green' : 'red')"
                    />
                  </div>
                  <q-btn
                    icon="refresh"
                    text-color="red"
                    :loading="hardwareRebooting"
                    @click="rebootHardware"
                  >
                    <q-tooltip>
                      Reboot Raspberry Pi
                    </q-tooltip>
                  </q-btn>
                </td>
              </tr>
              <tr v-if="electronMode">
                <td class="status-label">
                  <div>
                    Receipt Printer
                  </div>
                  <div
                    class="text-overline"
                    style="line-height: 18px"
                  >
                    Status: {{ electronPrinterStatus }}
                  </div>
                </td>
                <td class="text-center">
                  <q-icon
                    :name="electronPrinterConnected? 'check_circle' : 'warning'"
                    size="md"
                    :color="((!onLine || cableDisconnected || !hardware.status.connected) && 'grey') || (hardware.status.receiptPrinterConnected ? 'green' : 'red')"
                  />
                </td>
              </tr>
              <tr v-if="hardware && !electronMode">
                <td class="status-label">
                  Hardware Linked
                </td>
                <td class="text-center">
                  <q-toggle
                    v-if="!linkLoading"
                    keep-color
                    :color="((!onLine || cableDisconnected || !hardware.status.connected) && 'grey') || (linked ? 'green' : 'red')"
                    :model-value="linked"
                    :disable="linked"
                    unchecked-icon="clear"
                    checked-icon="check"
                    @click.stop
                    @update:model-value="$emit('toggle-link')"
                  />
                  <q-btn
                    v-else
                    :loading="true"
                    round
                  />
                </td>
              </tr>
              <tr v-if="hardware && hardware.config.hasReceiptPrinter && !electronMode">
                <td class="status-label">
                  Receipt Printer
                </td>
                <td class="text-center">
                  <q-icon
                    :name="hardware.status.receiptPrinterConnected ? 'check_circle' : 'warning'"
                    size="md"
                    :color="((!onLine || cableDisconnected || !hardware.status.connected) && 'grey') || (hardware.status.receiptPrinterConnected ? 'green' : 'red')"
                  />
                </td>
              </tr>
              <tr v-if="hardware && hardware.config.hasReceiptPrinter && !electronMode">
                <td class="status-label">
                  Cash Drawer
                </td>
                <td class="text-center">
                  <q-icon
                    :name="hardware.status.receiptPrinterConnected ? 'check_circle' : 'warning'"
                    size="md"
                    :color="((!onLine || cableDisconnected || !hardware.status.connected) && 'grey') || (hardware.status.receiptPrinterConnected ? 'green' : 'red')"
                  />
                </td>
              </tr>
              <tr v-if="hardware && hardware.config.hasRfidReader && !electronMode">
                <td class="status-label">
                  RFID Reader
                </td>
                <td class="text-center">
                  <q-icon
                    :name="hardware.status.rfidReaderConnected ? 'check_circle' : 'warning'"
                    size="md"
                    :color="((!onLine || cableDisconnected || !hardware.status.connected) && 'grey') || (hardware.status.rfidReaderConnected ? 'green' : 'red')"
                  />
                </td>
              </tr>
              <tr v-if="hardware && hardware.config.hasMagneticCardReade && !electronModer">
                <td class="status-label">
                  Magnetic Card Reader
                </td>
                <td class="text-center">
                  <q-icon
                    :name="hardware.status.magneticCardReaderConnected ? 'check_circle' : 'warning'"
                    size="md"
                    :color="((!onLine || cableDisconnected || !hardware.status.connected) && 'grey') || (hardware.status.magneticCardReaderConnected ? 'green' : 'red')"
                  />
                </td>
              </tr>
              <tr v-if="hardware && hardware.config.hasQrCodeReader && !electronMode">
                <td class="status-label">
                  QR Code Reader
                </td>
                <td class="text-center">
                  <q-icon
                    :name="hardware.status.qrCodeReaderConnected ? 'check_circle' : 'warning'"
                    size="md"
                    :color="((!onLine || cableDisconnected || !hardware.status.connected) && 'grey') || (hardware.status.qrCodeReaderConnected ? 'green' : 'red')"
                  />
                </td>
              </tr>
              <tr v-if="registerStation && registerStation.useStripeTerminalPayments">
                <td class="status-label">
                  <div>
                    Chip Reader {{ currentStripeTerminal ? `(${currentStripeTerminal})` : '' }}
                  </div>
                  <div
                    v-if="stripeTerminalReconnectionInProgress"
                  >
                    <div
                      class="text-overline"
                      style="line-height: 18px; color: red;"
                    >
                      Reconnect Attempt {{ stripeTerminalReconnectionAttempt + 1 }}
                    </div>
                    <div
                      v-if="stripeTerminalReconnectionError"
                      style="white-space: normal;"
                    >
                      {{ stripeTerminalReconnectionError }}
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <q-icon
                    :name="$payments.status.connected ? 'check_circle' : 'warning'"
                    size="md"
                    :color="((!onLine || $payments.status.connected === null) && 'grey') || ($payments.status.connected ? 'green' : 'red')"
                  />
                </td>
              </tr>
            </tbody>
          </q-markup-table>
        </div>
        <q-card-section />
      </q-card-section>
      <q-card-actions class="q-mx-sm">
        <q-btn
          label="Set Kiosk Station"
          size="lg"
          color="primary"
          @click="$emit('set-register-station')"
        />
        <q-btn
          v-if="registerStation.useStripeTerminalPayments"
          label="Set Chip Reader"
          size="lg"
          color="secondary"
          @click="() => $refs.selectStripeTerminalDialog.show()"
        />
        <q-btn
          v-else
          label="Payment Connector Maintenance"
          size="lg"
          color="secondary"
          @click="() => $refs.connectorActionDialog.show()"
        />
      </q-card-actions>
    </q-card>
    <select-stripe-terminal-dialog
      ref="selectStripeTerminalDialog"
    />
    <connector-action-dialog
      v-if="registerStation"
      ref="connectorActionDialog"
    />
  </q-dialog>
</template>

<script>

import { isElectronMode } from 'src/config'
import ConnectorActionDialog from 'src/modules/register/components/payment/ConnectorActionDialog'
import SelectStripeTerminalDialog from 'src/modules/register/components/SelectStripeTerminalDialog'

export default {
  name: 'HardwareManager',
  components: {
    SelectStripeTerminalDialog,
    ConnectorActionDialog
  },
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    hardware: {
      type: Object,
      required: true
    },
    onLine: {
      type: Boolean,
      required: true
    },
    cableDisconnected: {
      type: Boolean,
      required: true
    },
    linkLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    stripeTerminalReconnectionInProgress: {
      type: Boolean,
      required: false,
      default: false
    },
    stripeTerminalReconnectionAttempt: {
      type: Number,
      required: false,
      default: 0
    },
    stripeTerminalReconnectionError: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['toggle-link', 'set-register-station', 'update:model-value'],
  data () {
    return {
      shown: false,
      hardwareRebooting: false,
      electronPrinterLoading: false
    }
  },
  context: ['currentRegisterClient'],
  computed: {
    linked () {
      return this.currentRegisterClient?.id === this.hardware?.pessimisticData?.registerClientId
    },
    electronMode () {
      return isElectronMode
    },
    registerStation () {
      return this.currentRegisterClient?.registerStation
    },
    currentStripeTerminal () {
      return this.$payments.status.currentReader?.label
    },
    electronPrinterConnected () {
      if (!window.electronPrinter) {
        return false
      }
      return !window.electronPrinter.status()?.error
    },
    electronPrinterStatus () {
      if (!window.electronPrinter) {
        return ''
      }

      const status = window.electronPrinter.status()

      return (status.name || '') + ' ' + (status.status)
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
      if (this.shown && this.category) {
        this.$trackPage(this, { category: this.category.name })
      }
    }
  },
  methods: {
    show (category) {
      this.category = category
      this.shown = true
    },
    hide () {
      this.shown = false
    },
    async rebootHardware () {
      this.hardwareRebooting = true
      await this.hardware.triggerAction('reboot')
      this.hardwareRebooting = false
    }
  }
}

</script>
